import React, { Component } from 'react';
import { Button, Tabs, Row, Col, Modal, Icon, Input, message, Form, Table, LocaleProvider, DatePicker, Select, InputNumber, Popover } from 'antd';
import EventSet from "./../../../../../assets/PubJs/hcPub";//公用的所有事件
import { Hcurl } from "./../../../../../constants/index";//获取公共路径
import $ from "jquery";
import moment from 'moment';
import CompanyFristLogin from './../../CompanyCenter/CompanyFristLogin/CompanyFristLogin';
import createHistory from 'history/createHashHistory';//路由切换地址
import zhCN from 'antd/lib/locale-provider/zh_CN';
import "./../style.css"
const history = createHistory();//定义history路由
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const confirm = Modal.confirm;
var _CompanyRecord = null;
let errListContent = "";
let scrollFlag = 1;
var companyCode = EventSet.getQueryString('companyCode');//企业code
function GetDate(now, itype) {
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();
    if (itype === "yyyy-MM-dd hh:mm:ss") {
        return year + "-" + (month < 10 ? "0" + month : month) + "-" + (date < 10 ? "0" + date : date) + " " + (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute) + ':' + (second < 10 ? "0" + second : second);
    } else if (itype === "yyyy-MM-dd") {
        return year + "-" + (month < 10 ? "0" + month : month) + "-" + (date < 10 ? "0" + date : date);
    }
}
var date = new Date();
var Times = GetDate(date, 'yyyy-MM-dd');//投诉时间

function current() {
    var now = new Date(), str = '';
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();

    return str = year + '-' + (month < 10 ? "0" + month : month) + "-" + (date < 10 ? "0" + date : date) + " " + (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute) + ':' + (second < 10 ? "0" + second : second)
}
if (EventSet.getQueryString('ci_code') == '' || EventSet.getQueryString('ci_code') == undefined) {
    setInterval(function () { $(".divs").text(current) }, 1000);
}


let timeout;
var i = 0;
const fieldLabels1 = {
    tsName: "投诉人姓名",
    lxPhone: "联系电话",
    server: "商品/服务",
    content: "纠纷内容",
    result: "和解结果",
    zyMoney: "争议金额(元)",
    tpMoney: "退赔金额(元)",
    CP_HanderName: "受理人",
    banlicontent: "办理内容",
}
class CompanyRecord extends React.Component {
    state = {
        HanderNames: [],//受理人
        thisDate: moment(),
        tsTime: Times,//投诉日期
        buyTime: Times,//购货日期
        errorNum: 0,//错误总数
        visiblePopover: false,//错误提示弹窗显示
        errorTip: "none",//错误总数显示隐藏
        loading: false,
        DepartCode: "",
    }

    scrollFunction = () => {
        $(window.document).scroll(function () {
            if ($(document).scrollTop() >= 80) {
                $('#CompanyRecord').css('paddingBottom', '160px');
                $('.CompanyRecord_head').css({
                    position: "fixed",
                    top: 0,
                    width: "80%"
                });
            } else {
                $('.CompanyRecord_head').css({
                    position: "relative",
                    width: "100%",
                })
                $('#CompanyRecord').css('paddingBottom', '0px')
            }
        })
    }
    //登记时间

    getRegTime = () => {
        this.props.form.setFieldsValue({ time: i });
    }
    getUserInfo = () => {
        //this.regTime = setInterval(() => { this.getRegTime() }, 1000);
        this.GetCi_Code();
        $.ajax({
            url: Hcurl + "/user/GetUserInfo",
            type: "post",
            data: {
                CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code
            },
            headers: {
                token: JSON.parse(localStorage.getItem("userInfo")).token
            },
            async: false,
            success: function (res) {
                if (res != null && res != '') {
                    res = JSON.parse(res);
                    console.log(res, 'res');
                    _CompanyRecord.props.form.setFieldsValue({
                        person: res.userName, //登记人
                        CP_HanderName: res.userName,//受理人
                    });
                }
            },
            error: function (res) {
                history.push({ pathname: '/Login/LoginMain/LoginEntry', })
            }
        })
    }
    //获取企业企业直属部门Code
    GetComUEDepartmentCode = () => {
        $.ajax({
            url: Hcurl + "/AF_CompanyCaseInfo/GetComUEDepartmentCode?CompanyCode=" + EventSet.getQueryString('companyCode'),
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                if (data != '' && data != null) {
                    _CompanyRecord.setState({
                        DepartCode: data
                    })
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }
        })
    }
    //获取登记单 编号
    GetCi_Code = () => {
        $.ajax({
            url: Hcurl + "/AF_CompanyCaseInfo/GetCi_Code",
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            data: "",
            success: function (data) {
                if (data != '' && data != null) {
                    _CompanyRecord.props.form.setFieldsValue({
                        Code: data
                    })
                }
                _CompanyRecord.GetComUEDepartmentCode()

            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }
        })
    }
    //编辑登记单详情
    editInfo = () => {
        $.ajax({
            url: Hcurl + "/AF_CompanyCaseInfo/getCaseInfoDetail?ci_code=" + EventSet.getQueryString('ci_code'),
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                if (data != '' && data != null && data.length != 0) {
                    data = JSON.parse(data);
                    console.log(data, 'data');
                    $(".divs").text(data[0].CI_RegTime)
                    _CompanyRecord.props.form.setFieldsValue({
                        Code: data[0].CI_Code,
                        //time: data[0].CI_RegTime,//登记时间
                        person: data[0].JoinMan,//登记人
                        // company: data[0].CI_ComCode,//登记企业
                        tsTime: moment(data[0].CI_TypeTime, 'YYYY-MM-DD'),//投诉日期
                        tsName: data[0].CI_UserName,//投诉人姓名
                        lxPhone: data[0].CI_UserPhone,//联系电话
                        server: data[0].CI_ShopName,//商品/服务
                        buyTime: moment(data[0].CI_EventTime, 'YYYY-MM-DD'),//购货时间
                        content: data[0].CI_Content,//纠纷内容
                        result: data[0].CI_Result == 0 ? '和解成功' : "和解失败",//和解结果
                        zyMoney: data[0].CI_ShopMoney,//争议金额
                        tpMoney: data[0].CI_RedeemLoss,//退赔金额
                        CP_HanderName: data[0].CI_HanderName,//受理人
                        banlicontent: data[0].CI_FeedContent,//办理内容
                    })
                    _CompanyRecord.setState({
                        tsTime: data[0].CI_TypeTime,
                        buyTime: data[0].CI_EventTime,
                    });
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }
        })
    }
    componentDidMount() {
        _CompanyRecord = this;
        this.scrollFunction();
        if (EventSet.getQueryString('ci_code') != '' && EventSet.getQueryString('ci_code') != undefined) {
            this.editInfo();//编辑登记单信息
            this.props.form.setFieldsValue({
                company: EventSet.getUserInfo().XXHJCom_Name,//登记企业
            });
        } else {
            this.props.form.setFieldsValue({
                person: EventSet.getUserInfo().userName, //登记人
                company: EventSet.getUserInfo().XXHJCom_Name,//登记企业
                CP_HanderName: EventSet.getUserInfo().userName,//受理人
                tsTime: moment(new Date(), 'YYYY-MM-DD'),
                buyTime: moment(new Date(), 'YYYY-MM-DD'),
            });
            this.getUserInfo();
        }
    }
    myValidator1 = (rule, value, callback) => {
        //console.log(value);
        if (value != undefined) {
            if (value.length > 20) {
                //console.log('20个字以内');
                callback('20个字以内');
                return;
            } else {
                callback();
            }
        } else {
            callback();
        }
    }
    //投诉时间
    tsTimeChange = (value, dateString) => {
        console.log(value, dateString);
        this.setState({
            tsTime: dateString
        })
    }
    //购货时间
    buyTimeChange = (value, dateString) => {
        console.log(dateString, 'dateString');
        this.setState({
            buyTime: dateString
        })
    }
    //错误提示弹窗
    handleVisibleChange = (visiblePopover) => {
        this.setState({ visiblePopover });
    }
    btn = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            const { ...values } = fieldsValue;
            console.log(values, 'values');
            if (err) {
                console.log('err', err);
                let errLength = 0;

                //错误点击滚动
                const scrollToField = (fieldKey) => {
                    scrollFlag = 2;
                    $("html,body").animate({ scrollTop: $("label[for$=" + fieldKey + "]").offset().top - 150 }, 0, function () {
                        scrollFlag = 1;
                    });
                }
                errListContent = "";
                //错误列表数据
                errListContent = Object.keys(err).map(key => {
                    errLength++;
                    return (
                        <div className="errorList" onClick={() => scrollToField(key)} key={key}>
                            <Icon type="close-circle" style={{ marginRight: 7, color: "#f00" }} /><span >{err[key].errors[0].message}</span>
                            <div style={{ paddingLeft: 20 }}>{fieldLabels1[key]}</div>
                        </div>
                    )
                })
                this.setState({
                    errorNum: "表单校验信息(" + errLength + "条)",
                    errorTip: "inline-block"
                })
                message.warn("请检查后重新尝试");
                this.setState({ visiblePopover: true });
            } else {
                this.setState({
                    errorTip: "none"
                })
                console.log(values, 'values');
                _CompanyRecord.setState({
                    loading: true
                })
                if (EventSet.getQueryString('ci_code') != '' && EventSet.getQueryString('ci_code') != undefined) {
                    console.log('编辑');
                    $.ajax({                     //UpdateCompromiseInfo
                        url: Hcurl + "/AF_CompanyCaseInfo/UpdateCompromiseInfo",
                        type: "post",
                        headers: {
                            "token": EventSet.getUserInfo()['token']
                        },
                        data: {
                            CI_Code: values.Code,//登记编号
                            CI_TypeTime: _CompanyRecord.state.tsTime,//投诉时间
                            CI_UserName: values.tsName,//投诉人姓名
                            CI_UserPhone: values.lxPhone,//投诉人电话
                            CI_ShopName: values.server,//商品/服务名称
                            CI_ShopMoney: values.zyMoney.toString().indexOf('.') > 0 ? values.zyMoney : values.zyMoney + '.00',//争议金额
                            CI_EventTime: _CompanyRecord.state.buyTime,//购货时间
                            CI_Content: values.content,//纠纷内容
                            CI_Result: values.result,//解结果
                            CI_RedeemLoss: values.tpMoney.toString().indexOf('.') > 0 ? values.tpMoney : values.tpMoney + '.00',//退赔金额
                            CI_HanderName: values.CP_HanderName,//经办人
                            CI_FeedContent: values.banlicontent,//反馈内容
                            CI_OperateUserCode: EventSet.getUserInfo().CU_Code,
                        },
                        success: function (data) {
                            console.log(data, 'data')
                            if (data.indexOf('|') >= 0) {
                                if (data.split('|')[0] == 'true') {
                                    message.success(data.split('|')[1]);
                                    setTimeout(() => {
                                        _CompanyRecord.setState({
                                            loading: false
                                        });
                                        window.close();
                                    }, 300)
                                } else {
                                    message.warn(data.split('|')[1]);
                                    _CompanyRecord.setState({
                                        loading: false
                                    })
                                }
                            }
                        },
                        error: function (data) {
                            message.error('操作失败');
                            _CompanyRecord.setState({
                                loading: false
                            })
                            //history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                            console.log(data, 'error')
                        }
                    })
                } else {
                    console.log('新增');
                    var djContent = $('.divs').html();
                    console.log(djContent, 'djContent');
                    $.ajax({
                        url: Hcurl + "/AF_CompanyCaseInfo/AddCompromiseInfo",
                        type: "post",headers: {
                            "token": EventSet.getUserInfo()['token']
                        },
                        data: {
                            CI_Code: values.Code,//      _CompanyRecord.props.form.getFieldValue('Code'),//登记单编号
                            CI_RegTime: djContent,//  _CompanyRecord.props.form.getFieldValue('time'),//登记时间
                            CI_UserCode: EventSet.getUserInfo().CU_Code,//企业用户code
                            CI_DepartCode: _CompanyRecord.state.DepartCode,//企业直属部门Code
                            CI_ComCode: EventSet.getUserInfo().xxhjcompanycode,//EventSet.getQueryString('companyCode'),//企业code
                            CI_TypeTime: _CompanyRecord.state.tsTime,//          _CompanyRecord.props.form.getFieldValue('time'),//投诉时间
                            CI_UserName: values.tsName,//   _CompanyRecord.props.form.getFieldValue('tsName'),//投诉人姓名
                            CI_UserPhone: values.lxPhone,// _CompanyRecord.props.form.getFieldValue('lxPhone'),//投诉人电话
                            CI_ShopName: values.server,// _CompanyRecord.props.form.getFieldValue('server'),//商品/服务名称
                            CI_ShopMoney: values.zyMoney,// _CompanyRecord.props.form.getFieldValue('zyMoney'),//争议金额
                            CI_EventTime: _CompanyRecord.state.buyTime,// _CompanyRecord.props.form.getFieldValue('buyTime'),//购货时间
                            CI_Content: values.content,// _CompanyRecord.props.form.getFieldValue('content'),//纠纷内容
                            CI_Result: values.result,//和解结果 0 成功 1失败
                            CI_RedeemLoss: values.tpMoney,// _CompanyRecord.props.form.getFieldValue('tpMoney'),//退赔金额
                            CI_HanderName: values.CP_HanderName,// _CompanyRecord.props.form.getFieldValue('CP_HanderName'),//经办人或受理人
                            CI_FeedContent: values.banlicontent,// _CompanyRecord.props.form.getFieldValue('banlicontent'),//办理内容
                            JoinMan: EventSet.getUserInfo().CU_Code,//values.person,// _CompanyRecord.props.form.getFieldValue('person'),//登记人
                        },
                        success: function (data) {
                            console.log(data, 'data')
                            if (data.indexOf('|') >= 0) {
                                if (data.split('|')[0] == 'true') {
                                    message.success(data.split('|')[1]);
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 300)
                                } else {
                                    _CompanyRecord.setState({
                                        loading: false
                                    })
                                    if (data.split('|')[1] == '投诉单已存在') {
                                        confirm({
                                            title: '投诉单已存在',
                                            content: '当前投诉单已存在，请不要重复提交，您可以点击下方刷新按钮刷新页面后继续登记！',
                                            okText: "刷新",
                                            onOk() {
                                                window.location.reload();
                                            },
                                            onCancel() {
                                                //console.log('Cancel');
                                            },
                                        });
                                    } else {
                                        message.warn(data.split('|')[1])
                                    }
                                }
                            }
                        },
                        error: function (data) {
                            message.error('操作失败');
                            _CompanyRecord.setState({
                                loading: false
                            })
                            //history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                            console.log(data, 'error')
                        }
                    })
                }

            }
        })
    }
    btnCancel = () => {
        confirm({
            title: (EventSet.getQueryString('ci_code') != '' && EventSet.getQueryString('ci_code') != undefined) ? "还原" : "确定重置",
            content: (EventSet.getQueryString('ci_code') != '' && EventSet.getQueryString('ci_code') != undefined) ? "点击确定按钮后，可将本次变更内容进行还原。" : '重置后，相关文本输入内容会重新变为初始状态。',
            onOk() {
                window.location.reload();
            },
            onCancel() {
                //console.log('Cancel');
            },
        });

    }

    //受理人 模糊匹配
    Jfetchs(value, callback) {
        console.log(value, 'value');
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        function fake() {
            $.ajax({
                url: Hcurl + "/AF_CompanyCaseInfo/GetComUsers?companyCode=" + EventSet.getQueryString('companyCode') + '&searchName=' + value,
                type: "post",
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    console.log(data, 'data');
                    if (data != [] && data != null) {
                        console.log(123)
                        callback(JSON.parse(data));
                    } else {
                        let data = []
                        callback(data);
                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    console.log(data)
                }
            })
        }
        timeout = setTimeout(fake, 300);
    }
    // 受理人模糊匹配下拉框方法
    HanderNameChange(value) {
        console.log(value, 'value');

        _CompanyRecord.props.form.setFieldsValue({
            CP_HanderName: value
        })
        if (value != undefined) {
            _CompanyRecord.Jfetchs(value, data => _CompanyRecord.setState({ HanderNames: data }));
        }
    }
    // 受理人模糊匹配下拉框方法
    HanderNameSelect = (value, option) => {
        console.log(option, 'option');
        setTimeout(function () {
            _CompanyRecord.props.form.setFieldsValue({
                CP_HanderName: option.props.value
            })
        }, 20)
    }
    closePage = () => {
        window.opener = null;
        window.open('', '_self');
        window.close();
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xxl: { span: 6 },
                xl: { span: 7 },
                lg: { span: 8 },
                md: { span: 10 },
            },
            wrapperCol: {
                xxl: { span: 18 },
                xl: { span: 15 },
                lg: { span: 14 },
                md: { span: 10 },
            }
        };
        const formItemLayout1 = {
            labelCol: {
                xxl: { span: 3 },
                xl: { span: 3 },
                lg: { span: 4 },
                md: { span: 2 },
            },
            wrapperCol: {
                xxl: { span: 21 },
                xl: { span: 20 },
                lg: { span: 19 },
                md: { span: 21 },
            }
        };
        const style = {
            position: 'fixed',
            bottom: 0,
            right: 0,
            height: '56px',
            lineHeight: '56px',
            background: '#fff',
            borderTop: '1px solid #e8e8e8',
            padding: '0 24px',
            zIndex: 999,
            width: 'calc(100%)',
        }
        return (
            <div className='CompanyRecord'>
                <div id='CompanyRecord'>
                    <div className='CompanyRecord_head'>非平台纠纷和解登记表单填写：</div>
                    <div style={{ marginTop: 20, paddingBottom: 20 }}>
                        <Form>
                            <Row>
                                <Col span={8}>
                                    <FormItem
                                        label="登记编号"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('Code')(
                                            <Input placeholder='' disabled />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    {/*<FormItem
                                        label="登记时间"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('time')(
                                            <Input disabled id='time' type='text'/>
                                        )}
                                    </FormItem>*/}
                                    <Row>
                                        <Col md={10} lg={8} xl={7} xxl={6} style={{ color: "#333", textAlign: "right", height: 32, lineHeight: '32px' }}>
                                            登记时间：
                                        </Col>
                                        <Col md={10} lg={14} xl={15} xxl={18}>
                                            <div style={{ width: "100%", height: 32 }} className='divs'></div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={8}>
                                    <FormItem
                                        label="登记人"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('person')(
                                            <Input disabled />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem
                                        label="登记企业"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('company')(
                                            <Input disabled />
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8}>
                                    <LocaleProvider locale={zhCN}>
                                        <FormItem
                                            label="投诉日期"
                                            {...formItemLayout}
                                        >
                                            {getFieldDecorator('tsTime', {
                                                rules: [{
                                                    required: true, message: '请输入投诉时间',
                                                }],
                                            })(
                                                <DatePicker
                                                    allowClear={true}
                                                    format='YYYY-MM-DD'
                                                    onChange={this.tsTimeChange}
                                                    style={{ width: '100%' }}
                                                    showToday={false}
                                                />
                                                )}
                                        </FormItem>
                                    </LocaleProvider>
                                </Col>
                                {/**/}
                                <Col span={8}>
                                    <FormItem
                                        label="投诉人姓名"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('tsName', {
                                            rules: [{
                                                required: true, message: '请输入姓名',
                                            }],
                                        })(
                                            <Input
                                                maxLength='20'
                                            />
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem
                                        label="联系电话"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('lxPhone', {
                                            rules: [{
                                                required: true, message: '请输入联系电话',
                                            }, { pattern: /^\d{6,18}$/, message: '请输入有效的联系电话' }],
                                        })(
                                            <Input
                                                maxLength='18'
                                            />
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8}>
                                    <FormItem
                                        label="商品/服务"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('server', {
                                            rules: [{
                                                required: true, message: '请输入商品/服务名称',
                                            }],
                                        })(
                                            <Input
                                                maxLength='50'
                                            />
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <LocaleProvider locale={zhCN}>
                                        <FormItem
                                            label="购货时间"
                                            {...formItemLayout}
                                        >
                                            {getFieldDecorator('buyTime', {
                                                rules: [{
                                                    required: true, message: '请选择',
                                                }],
                                            })(
                                                <DatePicker
                                                    allowClear={false}
                                                    onChange={this.buyTimeChange}
                                                    style={{ width: '100%' }}
                                                    showToday={false}
                                                />
                                                )}
                                        </FormItem>
                                    </LocaleProvider>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={16}>
                                    <FormItem
                                        label="纠纷内容"
                                        {...formItemLayout1}
                                    >
                                        {getFieldDecorator('content', {
                                            rules: [{
                                                required: true, message: '请输入纠纷内容',
                                            }],
                                        })(
                                            <TextArea
                                                rows={6}
                                                maxLength='1000'
                                                placeholder='请输入投诉纠纷内容，1000字内'
                                            />
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8}>
                                    <FormItem
                                        label="和解结果"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('result', {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                        })(
                                            <Select

                                            >
                                                <Option value="0">和解成功</Option>
                                                <Option value="1">和解失败</Option>
                                            </Select>
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem
                                        label="争议金额(元)"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('zyMoney', {
                                            rules: [{
                                                required: true, message: '请输入争议金额',
                                            }],
                                        })(
                                            <InputNumber placeholder="单位：元" style={{ width: "100%" }} min={0.00} step={1} precision={2} max={999999999.99} parser={value => value == '' ? '0.00' : value} />
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem
                                        label="退赔金额(元)"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('tpMoney', {
                                            rules: [{
                                                required: true, message: '请输入退赔金额',
                                            }],
                                        })(
                                            <InputNumber placeholder="单位：元" style={{ width: "100%" }} min={0.00} step={1} precision={2} max={999999999.99} parser={value => value == '' ? '0.00' : value} />
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8}>
                                    <FormItem
                                        label="受理人"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_HanderName', {
                                            rules: [{ required: true, message: '请输入受理人' }, { validator: this.myValidator1 }],
                                        })(
                                            <Select
                                                allowClear
                                                mode="combobox"
                                                defaultActiveFirstOption={false}
                                                showArrow={false}
                                                filterOption={false}
                                                onChange={this.HanderNameChange}
                                                onSelect={this.HanderNameSelect}
                                            >
                                                {
                                                    (this.state.HanderNames).map(function (e) {
                                                        return <Option key={e.UCR_ComUserID} value={e.CU_UserName}>{e.CU_UserName}</Option>
                                                    })
                                                }
                                            </Select>
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={16}>
                                    <FormItem
                                        label="办理内容"
                                        {...formItemLayout1}
                                    >
                                        {getFieldDecorator('banlicontent', {
                                            rules: [{
                                                required: true, message: '请输入办理内容',
                                            }],
                                        })(
                                            <TextArea
                                                rows={6}
                                                maxLength='400'
                                                placeholder='请输入详细的办理内容，400字内'
                                            />
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={style}>
                                    <div style={{ textAlign: "center" }}>
                                        <span style={{ cursor: "pointer", fontSize: 15, paddingRight: 10, display: this.state.errorTip }} id="errorPrompt" className='Popovers'>
                                            <Popover
                                                content={errListContent}
                                                title={this.state.errorNum}
                                                trigger="click"
                                                visible={this.state.visiblePopover}
                                                onVisibleChange={this.handleVisibleChange}
                                                overlayStyle={{ fontSize: 14, width: 235 }}
                                                getTooltipContainer={() => document.getElementById("errorPrompt")}
                                            >
                                                <Icon type="exclamation-circle" style={{ color: "#f00", paddingRight: 5 }} />
                                            </Popover>
                                        </span>
                                        <Button onClick={this.btn} type="primary" style={{ marginRight: 20 }} loading={this.state.loading}>保存</Button>
                                        <Button onClick={this.btnCancel}>{(EventSet.getQueryString('ci_code') != '' && EventSet.getQueryString('ci_code') != undefined) ? "还原" : "重置"}</Button>
                                        <Button type="danger" ghost={true} style={{ marginBottom: 20 }} className='closeEdit' onClick={this.closePage}>关闭当前页面</Button>
                                    </div>

                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}
const CompanyRecordWrap = Form.create()(CompanyRecord);
export default CompanyRecordWrap;


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyAccord/CompanyRecord/CompanyRecord.js